import { connect } from 'react-redux';
import TssLane from 'Common/Map/OpenLayers/Tss/TssLane';
import { OpStatus, LanePollData, Midpoint, LinkGeometry, Lane, Node } from "NSwag/ServerClient/Client.nswag";
import { ILanes } from "Store/Tss/ILanes";
import { IDetectors } from "Store/Tss/IDetectors";
import { ILanePollData } from "Store/Tss/ILanePollData";
import Util from 'Util/index';
import { Action, Dispatch } from "redux/index";

interface IProps {
    index: number,
    opStatus: OpStatus,
    speedLimit: number,
    previousMidPoint: Midpoint | null,
    nextMidPoint: Midpoint | null,
    linkGeometry: LinkGeometry | null,
    startNode: Node | null,
    endNode: Node | null,
    map: any,
    vectorLayerSource: any,
    zoomLevel: number,
    lane: Lane
}

interface IState {
    lanes: ILanes,
    detectors: IDetectors,
    lanePollData: ILanePollData
}

/**
 * Maps the state to the props
 * @param {state} - current state
 * @param {props} - properies of the component
 */
const mapStateToProps = (state: IState, ownProps: IProps) => {
    let laneKey = Util.IdToString(ownProps.lane.id!);

    let lane = state.lanes[laneKey];
    let pollData = state.lanePollData[laneKey];

    return ({
        ...ownProps,
        pollData,
        lane: lane
    });
};

/**
 * 
 * @param {any} dispatch
 * @param {any} ownProps
 */
const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: IProps) => ({
});

/**
 * Connect the state and props to the component TssLane
 * */
const TssLaneContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(TssLane);

/**
 * exports TssLaneContainer as the default
 */
export default TssLaneContainer;